@if (loading) {
  <mat-spinner [diameter]="50" class="full-loading-spinner"></mat-spinner>
}
@if (!loading) {
  <mat-dialog-content class="dialog-distribution-content header_settings">
    <div class="dialog-distribution-content__title header-text">
      {{
        'confirm-deposit-distributions.component.confirm_deposit_distribution'
          | localise: 'Confirm Deposit Distribution'
      }}
      <div class="header-comment">
        <span>{{
          'confirm-deposit-distributions.component.need_to_add_new_bank_account'
            | localise: 'Need to add a new bank account?'
        }}</span
        >&nbsp;
        <a routerLink="/bank-accounts" [mat-dialog-close]="true">{{
          'confirm-deposit-distributions.component.go_to_bank_setting'
            | localise: 'Go to bank settings'
        }}</a>
      </div>
    </div>
    <div class="dialog-distribution-content__details">
      <div class="dialog-distribution-content__details__title header-text">
        {{
          'confirm-deposit-distributions.component.commission_details'
            | localise: 'Commission Details'
        }}
      </div>
      <div class="details">
        <table class="m-r-36">
          <tr>
            <td>
              {{
                'confirm-deposit-distributions.property_address'
                  | localise: 'Property Address'
              }}
            </td>
            <td>{{ details.line1Address }}</td>
          </tr>
          <tr>
            <td>
              {{
                'confirm-deposit-distributions.brokerage'
                  | localise: 'Brokerage'
              }}
            </td>
            <td>{{ details.brokerApi?.name }}</td>
          </tr>
          <tr>
            <td>
              {{
                'confirm-deposit-distributions.closing_date'
                  | localise: 'Closing Date'
              }}
            </td>
            <td>
              {{ details.closingDate | dateApp: formatDateEnum.MMMMDDYYYY }}
            </td>
          </tr>
          <tr>
            <td>
              {{
                'confirm-deposit-distributions.component.mls' | localise: 'MLS'
              }}
              #
            </td>
            <td>{{ details.mls }}</td>
          </tr>
        </table>
        <table>
          <tr>
            <td>
              {{
                'confirm-deposit-distributions.component.deposit_sent_date'
                  | localise: 'Deposit Sent Date'
              }}
            </td>
            <td>
              {{ details.paymentDate | dateApp: formatDateEnum.MMMMDDYYYY }}
            </td>
          </tr>
          <tr>
            <td>
              {{
                'confirm-deposit-distributions.net_commission'
                  | localise: 'Net Commission'
              }}
            </td>
            <td>
              {{
                details.agentCommissionAmount | currencyJs: { showSymbol: true }
              }}
            </td>
          </tr>
          <tr>
            <td>
              {{
                'confirm-deposit-distributions.cloc_repayment_commission'
                  | localise: 'Advance Repayment'
              }}
            </td>
            @if (balanceByDeal) {
              <td>
                {{
                  balanceByDeal.unpaidTotal | currencyJs: { showSymbol: true }
                }}
              </td>
            } @else {
              <td>
                {{
                  details.paymentFromPartner | currencyJs: { showSymbol: true }
                }}
              </td>
            }
          </tr>
          <tr>
            <td>
              {{
                'confirm-deposit-distributions.total_to_deposit'
                  | localise: 'Total to Deposit'
              }}
            </td>
            <td>
              {{ totalToDeposit | currencyJs: { showSymbol: true } }}
            </td>
          </tr>
        </table>
      </div>
      <mat-divider class="m-32"></mat-divider>
    </div>
    <div class="table_header">
      {{
        'confirm-deposit-distributions.component.accounts_distributions'
          | localise: 'Accounts & Distributions'
      }}
    </div>
    <div class="payroll-block">
      <div class="forms-support-dark-mode table-wrapper">
        <table>
          <tr class="header-table">
            <th class="table-19-per">
              {{
                'confirm-deposit-distributions.component.account'
                  | localise: 'Account'
              }}
            </th>
            <th class="table-12-per distribution-col-mobile">
              {{
                'confirm-deposit-distributions.component.distribution'
                  | localise: 'Distribution'
              }}&nbsp;(%)
            </th>
            <th class="table-12-per distribution-col-mobile">
              {{
                'confirm-deposit-distributions.component.distribution'
                  | localise: 'Distribution'
              }}&nbsp;($)
            </th>
            <th class="table-12-per">
              {{
                'confirm-deposit-distributions.component.type'
                  | localise: 'Type'
              }}
            </th>
            <th class="table-19-per">
              {{
                'confirm-deposit-distributions.component.transaction_type'
                  | localise: 'Transaction Type'
              }}
            </th>
            <th class="table-19-per">
              {{
                'confirm-deposit-distributions.component.fee_percent'
                  | localise: 'Fee (Percent)'
              }}
            </th>
            <th class="table-12-per distribution-col-tbl">
              {{
                'confirm-deposit-distributions.component.distribution'
                  | localise: 'Distribution'
              }}&nbsp;($)
            </th>
            <th class="table-12-per distribution-col-tbl">
              {{
                'confirm-deposit-distributions.component.distribution'
                  | localise: 'Distribution'
              }}&nbsp;(%)
            </th>
          </tr>
          <tr class="standard_transfer">
            <td colspan="6" class="has-tooltip">
              <img src="/assets/img/icons/bank.svg" alt="" />
              <span>
                {{
                  'confirm-deposit-distributions.component.bank_accounts_standard_transfer'
                    | localise: 'Bank Accounts - Standard Transfer'
                }}
              </span>
              <img
                (mouseenter)="showTooltipStandard = true"
                (mouseleave)="showTooltipStandard = false"
                (click)="showTooltip()"
                src="/assets/img/icons/info.svg"
                alt="" />
              <div class="icon-tooltip">
                <div
                  class="block-tooltip"
                  [class.show-tooltip]="showTooltipStandard">
                  <div>
                    <div class="header-tooltip">
                      <img
                        class="m-0"
                        src="/assets/img/icons/bank-white.svg"
                        alt="" />
                      <span>
                        {{
                          'dashboard-payroll-settings.component.bank_accounts_standard_transfer'
                            | localise: 'Bank Accounts - Standard Transfer'
                        }}
                      </span>
                    </div>
                    <div>
                      {{
                        'dashboard-payroll-settings.component.accounts_used_standard_transfers'
                          | localise
                            : 'These accounts are used for standard ACH transfers. These transfers are typically posted by the next business day.'
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          @for (app of bankAccounts; track app) {
            <tr [class.limpid]="!editPercentBankAccountsMap[app.id]">
              <td class="crop-text-mobile">
                {{
                  app.accountNickname ? app.accountNickname : app.institution
                }}
                {{ app.accountNumber }}
              </td>
              <td class="distribution-col-mobile">
                <input
                  [class.err-percent]="totalPercent.value !== 100"
                  class="distribution-percent"
                  [disabled]="saving"
                  type="text"
                  mask="0*"
                  suffix="%"
                  placeholder="0%"
                  appDisableAutofill
                  [(ngModel)]="editPercentBankAccountsMap[app.id]"
                  thousandSeparator=","
                  (change)="calcPercent()" />
              </td>
              <td class="distribution-col-mobile">
                @if (editPercentBankAccountsMap[app.id]) {
                  ${{
                    totalToDeposit
                      .multiply(editPercentBankAccountsMap[app.id])
                      .divide(100) | currencyJs
                  }}
                }
                @if (!editPercentBankAccountsMap[app.id]) {
                  N/A
                }
              </td>
              <td class="capitalize-first-letter">{{ app.accountType }}</td>
              <td>
                {{
                  'confirm-deposit-distributions.component.standard'
                    | localise: 'Standard'
                }}
              </td>
              <td>N/A</td>
              <td class="distribution-col-tbl">
                @if (editPercentBankAccountsMap[app.id]) {
                  ${{
                    totalToDeposit
                      .multiply(editPercentBankAccountsMap[app.id])
                      .divide(100) | currencyJs
                  }}
                }
                @if (!editPercentBankAccountsMap[app.id]) {
                  N/A
                }
              </td>
              <td class="distribution-col-tbl">
                <input
                  [class.err-percent]="totalPercent.value !== 100"
                  class="distribution-percent"
                  [disabled]="saving"
                  type="text"
                  mask="0*"
                  suffix="%"
                  placeholder="0%"
                  appDisableAutofill
                  [(ngModel)]="editPercentBankAccountsMap[app.id]"
                  thousandSeparator=","
                  (change)="calcPercent()" />
              </td>
            </tr>
          }
          @if (astraCards.length > 0 || ingoCards.length > 0) {
            <tr class="standard_transfer">
              <td colspan="6" class="has-tooltip">
                <img src="/assets/img/icons/flash.svg" alt="" />
                <span
                  >{{
                    'confirm-deposit-distributions.component.debit_cards_instant_transfer'
                      | localise: 'Debit Cards - Instant Transfer'
                  }}
                </span>
                <img
                  (mouseenter)="showTooltipInstant = true"
                  (mouseleave)="showTooltipInstant = false"
                  (click)="showHideTooltipInstant()"
                  src="/assets/img/icons/info.svg"
                  alt="" />
                <div class="icon-tooltip">
                  <div
                    class="block-tooltip"
                    [class.show-tooltip]="showTooltipInstant">
                    <div>
                      <div class="header-tooltip">
                        <mat-icon>flash_on</mat-icon>
                        {{
                          'dashboard-payroll-settings.component.debit_cards_instant_transfer'
                            | localise: 'Debit Cards - Instant Transfer'
                        }}
                      </div>
                      <div>
                        {{
                          'dashboard-payroll-settings.component.debit_cards_used_for_instant_transfer'
                            | localise
                              : 'Debit cards are used for instant transfer. Receive your funds in less than 30 minutes for 1.75% fee.'
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          }
          @for (app of astraCards; track app) {
            <tr [class.limpid]="!editPercentBankAccountsMap[app.id]">
              <td>
                {{ app.firstName + ' ' + app.lastName }} ******
                {{ app.lastFourDigits }}
              </td>
              <td class="distribution-col-mobile">
                <input
                  [class.err-percent]="totalPercent.value !== 100"
                  class="distribution-percent"
                  [disabled]="saving"
                  type="text"
                  mask="0*"
                  suffix="%"
                  placeholder="0%"
                  appDisableAutofill
                  [(ngModel)]="editPercentBankAccountsMap[app.id]"
                  thousandSeparator=","
                  (change)="calcPercent()" />
              </td>
              <td class="distribution-col-mobile">
                @if (editPercentBankAccountsMap[app.id]) {
                  ${{
                    totalToDeposit
                      .multiply(editPercentBankAccountsMap[app.id])
                      .divide(100) | currencyJs
                  }}
                }
                @if (!editPercentBankAccountsMap[app.id]) {
                  N/A
                }
              </td>
              <td class="capitalize-first-letter">{{ app.accountType }}</td>
              <td>
                {{
                  'confirm-deposit-distributions.component.instant'
                    | localise: 'Instant'
                }}
              </td>
              <td>{{ instantFeePercent }}%</td>
              <td class="distribution-col-tbl">
                @if (editPercentBankAccountsMap[app.id]) {
                  ${{
                    totalToDeposit
                      .multiply(editPercentBankAccountsMap[app.id])
                      .divide(100) | currencyJs
                  }}
                }
                @if (!editPercentBankAccountsMap[app.id]) {
                  N/A
                }
              </td>
              <td class="distribution-col-tbl">
                <input
                  [class.err-percent]="totalPercent.value !== 100"
                  class="distribution-percent"
                  [disabled]="saving"
                  type="text"
                  mask="0*"
                  suffix="%"
                  placeholder="0%"
                  appDisableAutofill
                  [(ngModel)]="editPercentBankAccountsMap[app.id]"
                  thousandSeparator=","
                  (change)="calcPercent()" />
              </td>
            </tr>
          }
          @for (app of ingoCards; track app) {
            <tr [class.limpid]="!editPercentBankAccountsMap[app.id]">
              <td>
                {{ app.issuingNetwork }} ******
                {{ app.last4 }}
              </td>
              <td class="capitalize-first-letter"></td>
              <td>
                {{
                  'confirm-deposit-distributions.component.instant'
                    | localise: 'Instant'
                }}
              </td>
              <td>{{ instantFeePercent }}%</td>
              <td>
                @if (editPercentIngoCardsMap[app.id]) {
                  ${{
                    totalToDeposit
                      .multiply(editPercentIngoCardsMap[app.id])
                      .divide(100) | currencyJs
                  }}
                }
                @if (!editPercentIngoCardsMap[app.id]) {
                  N/A
                }
              </td>
              <td>
                <input
                  [class.err-percent]="totalPercent.value !== 100"
                  class="distribution-percent"
                  [disabled]="saving"
                  type="text"
                  mask="0*"
                  suffix="%"
                  placeholder="0%"
                  appDisableAutofill
                  [(ngModel)]="editPercentIngoCardsMap[app.id]"
                  thousandSeparator=","
                  (change)="calcPercent()" />
              </td>
            </tr>
          }
        </table>
      </div>
    </div>
    <div class="payroll-block m-t-24">
      <div class="forms-support-dark-mode table-wrapper">
        @if (partnerList) {
          <table class="external">
            <tr class="standard_transfer external-accounts">
              <td colspan="6" class="has-tooltip">
                <img src="/assets/img/icons/user-multiple-group.svg" alt="" />
                <span>
                  {{
                    'confirm-deposit-distributions.component.external_accounts'
                      | localise: 'External Accounts'
                  }}
                </span>
                <img src="/assets/img/icons/info-primery.svg" alt="" />
              </td>
            </tr>
            @for (partner of partnerList; track partner) {
              @for (app of partner.brokerBankAccount; track app) {
                <tr [class.limpid]="!editPercentBrokerBankMap[app.id]">
                  <td class="table-19-per crop-text-mobile">
                    {{ partner.name }}
                  </td>
                  <td class="table-12-per distribution-col-mobile">
                    <input
                      [class.err-percent]="totalPercent.value !== 100"
                      class="distribution-percent"
                      [disabled]="saving"
                      type="text"
                      mask="0*"
                      suffix="%"
                      placeholder="0%"
                      appDisableAutofill
                      [(ngModel)]="editPercentBrokerBankMap[app.id]"
                      thousandSeparator=","
                      (change)="calcPercent()" />
                  </td>
                  <td class="table-12-per distribution-col-mobile">
                    @if (editPercentBrokerBankMap[app.id]) {
                      ${{
                        totalToDeposit
                          .multiply(editPercentBrokerBankMap[app.id])
                          .divide(100) | currencyJs
                      }}
                    }
                    @if (!editPercentBrokerBankMap[app.id]) {
                      N/A
                    }
                  </td>
                  <td class="table-12-per distribution-first-letter">
                    {{ app.accountNickname }}
                  </td>
                  <td class="table-19-per">-</td>
                  <td class="table-19-per">N/A</td>
                  <td class="table-12-per distribution-col-tbl">
                    @if (editPercentBrokerBankMap[app.id]) {
                      ${{
                        totalToDeposit
                          .multiply(editPercentBrokerBankMap[app.id])
                          .divide(100) | currencyJs
                      }}
                    }
                    @if (!editPercentBrokerBankMap[app.id]) {
                      N/A
                    }
                  </td>
                  <td class="table-12-per distribution-col-tbl">
                    <input
                      [class.err-percent]="totalPercent.value !== 100"
                      class="distribution-percent"
                      [disabled]="saving"
                      type="text"
                      mask="0*"
                      suffix="%"
                      placeholder="0%"
                      appDisableAutofill
                      [(ngModel)]="editPercentBrokerBankMap[app.id]"
                      thousandSeparator=","
                      (change)="calcPercent()" />
                  </td>
                </tr>
              }
            }
          </table>
        }
      </div>
    </div>
    <div class="display-flex-mobile">
      <div
        class="success"
        [class.err-percent]="!equalPercent"
        [class.equal-percent]="equalPercent">
        @if (!equalPercent) {
          <div class="not-equals">
            <div class="icon-size">
              <mat-icon>priority_high</mat-icon>
            </div>
            <div class="m-0-16 text-equal f-s-15">
              <b>{{
                'confirm-deposit-distributions.component.account_distributions_need'
                  | localise
                    : 'Your account distributions need to equal 100% before confirming'
              }}</b>
            </div>
            <div class="total-equal">
              {{ totalPercent | currencyJs: { withoutDecimal: true } }}%
            </div>
          </div>
        } @else {
          <div class="equal">
            <mat-icon>done</mat-icon>
            <div class="m-0-16 f-s-15">
              <b>{{
                'confirm-deposit-distributions.componen.distributions_equal'
                  | localise: 'Your distributions are equal to'
              }}</b>
            </div>
            <div class="total-equal">
              {{ totalPercent | currencyJs: { withoutDecimal: true } }}%
            </div>
          </div>
        }
      </div>
      <div class="confirm_btns">
        <button class="action-button" (click)="dialogRef.close()">
          {{
            'confirm-deposit-distributions.component.cancel_button'
              | localise: 'Cancel'
          }}
        </button>
        <button
          class="confirm"
          [disabled]="!equalPercent"
          (click)="confirmDeposit()">
          {{
            'confirm-deposit-distributions.component.confirm_distributions'
              | localise: 'Confirm Distributions'
          }}
        </button>
      </div>
    </div>
  </mat-dialog-content>
}
